import { Component, input } from '@angular/core'

@Component({
  selector: '[app-labeled-display]',
  template: `
        <span class="label">{{ label() }}</span>
        {{ value() ?? '-' }}
    `,
  styles: `
        :host {
            position: relative;
            margin-top: 0.5rem;
            
            .label {
                position: absolute;
                font-size: 0.7rem;
                line-height: 0.8rem;
                opacity: 0.8;
                top: -0.5rem;
                width:  100%;
                text-overflow: ellipsis;
            }
        }
    `,
})
export class LabeledDisplayComponent {
  value = input<string | undefined>('')
  label = input<string>()
}